export const capitalize = (string) => {
    if (string && typeof string === 'string') {
        return `${string[0].toUpperCase()}${string.slice(1)}`;
    }
    else {
        return null;
    }
}
